/**
 * Created by mykurisu on 2017/8/8.
 */
import React from 'react'
import {connect} from 'react-redux'
import {WKTag} from '../wk'
import { isLZWKAPP } from '../../utils'
import { toLecture, toChannel } from '../../utils/connectApp'
// import '../../css/wkCommon.css'
import '../../css/page/WKCurrencyItemForIndex.css'
import Running from '../../images/main/index_running_lecture.png'
import couponTagSmBgImg from '../../images/main/coupon_tag_sm_bg.png'


class WKCurrencyItemForIndex extends React.Component {
    static defaultProps = {
        border: 'top',
        marginBottom: false,
        attr: ''
    };

    renderBorder(type) {
        if(!this.props.HiddenBorder) {
            switch (this.props.content.type) {
                case 'top':
                    return 'currency-item-border-top';
                case 'bottom':
                    return 'currency-item-border-bottom';
                case 'none':
                    return 'currency-item-border-none';
                default:
                    return 'currency-item-border-top';
            }
        }
    }

    renderLectureMode() {
        const lecture = this.props.content;
        if (lecture.lecture_content.type === 'password_lecture') {
            return (
                <span className="liveroom-lecture-tag">
                    <i className="icon iconfont icon-suo tag-mode-fontsize"></i>
                </span>
            )
        }
    }

    renderLectureImageMode() {
        const lecture = this.props.content;
        if (lecture.image_mode === 'ppt' && lecture.lecture_mode === 'default'){
            return <WKTag text={'PPT'}/>;
        }
    }

    renderLectureTag() {
        const lecture = this.props.content;
        if (lecture.lecture_mode === 'default'){
            switch (lecture.image_mode) {
                case 'video':
                    return <WKTag text={'视频'}/>;
                case 'audio':
                    return <WKTag text={'音频'}/>;
                default:
                    return true
            }
        }else {
            switch (lecture.lecture_mode) {
                case 'video':
                    return <WKTag text={'视频'}/>;
                case 'audio':
                    return <WKTag text={'音频'}/>;
                default:
                    return true
            }
        }
    }

    renderLectureTime() {
        const lecture = this.props.content;

        if(lecture.lecture_mode==='video' || lecture.lecture_mode==='audio'){
            return (
                <p>时长<span>{lecture.audio_length}</span>分钟</p>
            )
        }

        if (lecture.status === 'closed'){
            if (lecture.audio_length <= 5){
                return (
                    <p>{lecture.start_time.split(' ')[0]}</p>
                )
            }else {
                return (
                    <p>时长<span>{lecture.audio_length}</span>分钟</p>
                )
            }
        }else {
            return (
                <p>{lecture.status_name}</p>
            )
        }
    }

    handleClick(url) {
        let link = url
        const {content} = this.props;
        if (content.stype === 'coupon') {
            link += `&${content.meta.params}`
        }
        window.location.href = link
    }

    renderPrice() {
        const {content} = this.props;
        if (content.stype === 'coupon') {
            return (
                <div className="coupon-tag-sm">
                    <div className="coupon-tag-sm-text">立减{content.meta && content.meta.desc}元</div>
                </div>
            )
        }
        if (content.need_money){
            if (content.has_limitmoney){
                if (Number(content.limit_money) === 0){
                    return <p><span>限时免费</span></p>
                }else {
                    return <p><i style={{fontStyle:'normal',fontSize: 12}}>￥</i>{content.limit_money.split('.')[0]}<span>.{content.limit_money.split('.')[1]}</span></p>
                }
            }else {
                return <p><i style={{fontStyle:'normal',fontSize: 12}}>￥</i>{content.lecture_money.split('.')[0]}<span>.{content.lecture_money.split('.')[1]}</span></p>
            }
        }else {
            if(content.lecture_type === 'open_lecture'){
                return <span style={{fontWeight:'500'}}>免费</span>
            }else{
                return null
            }
        }
    }

    render() {
        const {content, marginBottom, relayShow, attr, HiddenBorder} = this.props;
        const youxuanStyle = {
            top: 2,
            position: 'relative',
            marginRight: 7,
            width: 35,
            display: 'inline-block',
        }
        return (
            <div className={"wk-currency-item " + this.renderBorder(this.props.border) + (marginBottom ? ' currency-item-margin-bottom' : '')} onClick={() => this.handleClick(content.url)}>
                <div className="currency-item-left">
                    <div className="currency-item-img background-image" style={{backgroundImage: `url(${content.cover_url ? content.cover_url : content.cover})`}}>
                        {
                            content.stype === 'coupon' && (
                                <div>
                                    <div className="coupon-tag-big"></div>
                                    <div className="coupon-tag-big-text">
                                        <p>立减</p>
                                        <p><span>{content.meta && content.meta.desc}</span></p>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
                <div className="currency-item-right">
                    <div className="currency-item-right-title">
                        {content.is_preffered && (
                        <div style={youxuanStyle}>
                            <img src={require('../../images/youxuan@3x.png')} alt=""/>
                        </div>
                        )

                        }
                        {content.type && content.type === 'lecture' && !content.is_preffered &&
                            this.renderLectureTag()
                        }
                        {content.type && content.type === 'lecture' && !content.is_preffered &&
                        this.renderLectureImageMode()
                        }
                        {relayShow && content.is_relay &&
                        '【转】'
                        }
                        {content.name}
                    </div>
                    <div className="currency-item-right__container">
                        {content.status_name === '正在直播' &&
                        <div className="currency-item-right-mid">
                            <div className="currency-item-right-mid__running">
                                <img src={Running} alt=""/>
                                正在直播
                            </div>
                        </div>
                        }
                        <div className="currency-item-right-bottom">
                            <div className="currency-item-right-bottom_left">
                                <div className="currency-item-right-bottom_left-count-time">
                                    {content.type && content.type === 'channel' &&
                                    <p>已更新<span>{content.current_status_display.replace('已更新', '').replace('期', '').replace('节课程', '').replace('含', '')}</span>期</p>
                                    }
                                    {(content.type && content.type === 'lecture') &&
                                    this.renderLectureTime()
                                    }
                                </div>
                                <div className="currency-item-right-bottom_left-count">
                                    <span>{content.popular >= 10000 ? (content.popular / 10000).toFixed(2) + '万' : content.popular}</span>人气
                                </div>
                            </div>
                            {(content.type && content.type === 'lecture' && attr !== 'history' && attr !== 'starting') &&
                            <div className="currency-item-right-bottom_right">
                                {content.has_limitmoney && Number(content.limit_money) > 0 && content.stype !== 'coupon' &&
                                <p className="currency-item-right-bottom_right-limit"><del>￥{content.lecture_money}</del></p>
                                }
                                {this.renderPrice()}
                            </div>
                            }
                            {content.type && content.type === 'channel' &&
                            <div className="currency-item-right-bottom_right">
                                {content.has_limitmoney && Number(content.limit_money) > 0 && content.stype !== 'coupon' &&
                                <p className="currency-item-right-bottom_right-limit"><del>￥{content.lecture_money}</del></p>
                                }
                                {this.renderPrice()}
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(state => ({

}))(WKCurrencyItemForIndex)


// WEBPACK FOOTER //
// ./src/components/wk/WKCurrencyItemForIndex.js